import { React, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export default function Constitution() {
    const { t } = useTranslation();
    const [currentLanguage, setCurrentLanguage] = useState(localStorage.getItem("lang"));
    useEffect(() => {
        setCurrentLanguage(localStorage.getItem("lang"));
    }, []);
    useEffect(() => {
        console.log('use effect local storage', localStorage.getItem("lang"));
    }, [currentLanguage]);
    const dynamicStyle = {
        'text-align': localStorage.getItem("lang") === "ar" ? 'right' : 'left',
        'listStyleType': localStorage.getItem("lang") === "ar" ? 'none' : null
    }
    return (<div style={dynamicStyle}>
        <p style={dynamicStyle}>
            <strong>{t("Name.Name")} </strong>
            {
                t("Name.Info")
                    .split(".")
                    .map(
                        (item, index) => (
                            <lo>{item}</lo>
                        )
                    )
            }
        </p>
        <p style={dynamicStyle}><strong>{t("Headquarters.Name")} </strong>{t("Headquarters.Info").split(".").map((item, index) => (<lo>{item}</lo>))}</p>
        <p style={dynamicStyle}><strong>{t("Legal_Nature.Name")} </strong>{t("Legal_Nature.Info").split(".").map((item, index) => (<lo>{item}</lo>))}</p>
        <p style={dynamicStyle}><strong>{t("Objectives.Name")} </strong>{t("Objectives.Info").split(".").map((item, index) => (<li>{item}</li>))}</p>
        <p style={dynamicStyle}><strong>{t("General_Principles.Name")} </strong>{t("General_Principles.Info").split(".").map((item, index) => (<li>{item}</li>))}</p>
        <p style={dynamicStyle}><strong>Membership</strong><br />
            <strong>{
                t("Membership.EligibilityRequirements.Name")
            }</strong>
            <ui style={dynamicStyle}>{
                t("Membership.EligibilityRequirements.Info").split(".").map((item, index) => (<li>{item}</li>))
            }
            </ui><br />
            <ui style={dynamicStyle}>
                <strong>{t("Membership.MemberRights.Name")}</strong><br />
                {
                    t("Membership.MemberRights.Info")
                        .split(".")
                        .map(
                            (item, index) => (<li>{item}</li>)
                        )
                }
            </ui><br />
            <strong>{t("Membership.LossOfMembership.Name")}</strong>
            <ui style={dynamicStyle}>
                {
                    t("Membership.LossOfMembership.Info")
                        .split(".")
                        .map(
                            (item, index) => (<li>{item}</li>)
                        )
                }
            </ui>
        </p>
        <p style={dynamicStyle}><strong >
        </strong>{t("Structure_of_the_Association.Name")}
            {
                t("Structure_of_the_Association.Info")
                    .split(".")
                    .map(
                        (item, index) => (<li>{item}</li>)
                    )
            }
        </p>
        <p style={dynamicStyle}>
            <strong > {t("Executive_Committee.Name")}</strong>
            {
                t("Executive_Committee.Info")
                    .split(".")
                    .map(
                        (item, index) => (<li>{item}</li>)
                    )
            }
        </p>
        <p style={dynamicStyle}>
            <strong >{t("Meetings.Name")}</strong>
            {
                t("Meetings.Info")
                    .split(".")
                    .map(
                        (item, index) => (<li>{item}</li>)
                    )
            }
        </p>
        <p style={dynamicStyle}>
            <strong >Financial Resources: </strong><br />
            <ui style={dynamicStyle}>
                <strong >{t("Financial_Resources.Sources_of_Funding.Name")}</strong><br />
                {t("Financial_Resources.Sources_of_Funding.Info").split(".").map(
                    (item, index) => (
                        <li>
                            {item}
                        </li>
                    ))
                }</ui><br />
            <strong >{t("Financial_Resources.Use_of_Funds.Name")}</strong><br />
            <lo style={dynamicStyle}>{t("Financial_Resources.Use_of_Funds.Info").split(".").map(
                (item, index) => (
                    <li>
                        {item}
                    </li>))
            }</lo>
        </p>
        <p style={dynamicStyle}>
            <strong>{t("Dissolution_of_the_Association.Name")} </strong>
            {
                t("Dissolution_of_the_Association.Info").split(".").map(
                    (item, index) => (
                        <li>
                            {item}
                        </li>))
            }</p>
        <p style={dynamicStyle}>
            <strong>{t("Final_Provisions.Name")} </strong>
            {t("Final_Provisions.Info").split(".").map(
                (item, index) => (
                    <li>
                        {item}
                    </li>))
            }</p>
    </div>);
}